import { useEffect, useMemo, useState } from 'react';
import AppointmentUtils from 'services/AppointmentUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';

const RETRY_TIMEOUT = 60 * 60 * 1000;

function useFetchPatients(items: { patient_id?: string }[], ids?: string[]) {
  const dispatch = useAppDispatch();
  const patients = useAppSelector((state) => state.patients.byId);
  const [loadingPatients, setLoadingPatients] = useState(false);

  const patientsToGetIds = useMemo(() => {
    return (ids || AppointmentUtils.getMissingPatients(items, patients)).filter((id) => !!id);
  }, [items, patients, ids]);

  useEffect(() => {
    if (patientsToGetIds.length > 0 && !loadingPatients) {
      setLoadingPatients(true);
      dispatch(
        api.Patients.getMultiplePatients({ multipleValuesPayload: { values: patientsToGetIds } }),
      ).then((patients) => {
        if (patients?.length ?? 0 > 0) {
          setLoadingPatients(false);
        } else {
          setTimeout(() => {
            setLoadingPatients(false);
          }, RETRY_TIMEOUT);
        }
      });
    }
  }, [patientsToGetIds, dispatch, loadingPatients]);
  return [loadingPatients];
}

export default useFetchPatients;
